import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {Col, Container, Modal, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import CloseButton from "../CloseButton";
import SimpleBar from "simplebar-react";
import {gsap,Power4} from "gsap";

const AboutSection = ({data}) => {

// filter data
    const allData = data?.posts?.list;

    const [modalData , setModalData] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (data) => {
        setModalData(data)
        setShow(true);
    }
    const [offset, setOffset] = useState(0)

    const modalRef = useRef(null);


    useEffect(()=>{
        const pop = gsap.timeline({
            paused: true,
        });

        pop.to(".team-modal", {
            duration: 1.2,
            opacity: 1,
            x: 0,
            scale: 1,
            ease: Power4.easeOut,
        });
        modalRef.current = { open: pop };
    },[])

    useEffect(() => {
        if (show) {
            modalRef.current.open.restart().play();
        }
    }, [show]);



    // missing vision overflow
    const [overflow, setOverflow] = useState(0);
    useEffect(() => {
        if (document.querySelector(".mission-vision__single")) {
            setOverflow(
                document.querySelector(".mission-vision__single").clientHeight
            );
            window.addEventListener("resize", () => {
                if (window.innerWidth > 900) {
                    setOverflow(
                        document.querySelector(".mission-vision__single").clientHeight
                    );
                }
            });
        }
    }, []);

    return (
        <StyledAboutSection className='pb-150'>
            <div
                className="mission-vision">
                <Container>
                    <Row>
                        {allData?.length > 0 && allData?.map((i,index) =>(
                            <Col md={4} onClick={()=>handleShow(i)}>
                                <div className="mission-vision__single">
                                    <h3 className={'split-up'}>{i?.data?.subtitle}</h3>
                                    {index === 0 && (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="79.418" height="100" viewBox="0 0 79.418 100">
                                            <path id="_Downloader.la_-65268f74eca2b-03" data-name="[Downloader.la]-65268f74eca2b-03" d="M39.674,99.957c-2.687,0-5.371-.025-8.059.006a4.593,4.593,0,0,1-4.5-2.627,13.825,13.825,0,0,0-4.7-5.773c-.85-.553-1.271-2.15-1.407-3.326a43.787,43.787,0,0,1-.13-6.313,12.5,12.5,0,0,0-5-10.566A41.669,41.669,0,0,1,6.368,61.1C-.691,49.665-1.921,37.478,2.884,25.063,8.018,11.791,17.926,3.347,31.954.754,54.3-3.375,73.77,9.922,78.269,30.456c3.481,15.886-.888,29.639-13.8,40.1-3.933,3.187-6.121,6.965-5.861,12.1a30.738,30.738,0,0,1-.123,5.836A5.274,5.274,0,0,1,56.9,91.712,13.758,13.758,0,0,0,52.914,96.5a5.818,5.818,0,0,1-6.133,3.481c-2.358-.168-4.739-.035-7.107-.035v.009ZM41.1,72.07a7.741,7.741,0,0,0,.9.142c5.109,0,10.218.016,15.327-.044A2.869,2.869,0,0,0,59,71.454c1.748-1.508,3.446-3.076,5.125-4.66,10.3-9.744,14.688-21.577,11.236-35.471C71.63,16.328,61.776,6.856,46.686,3.634,34.357,1,23.491,4.64,14.335,13.372a36.058,36.058,0,0,0,.3,52.676c1.774,1.647,3.528,3.326,5.416,4.837a5.336,5.336,0,0,0,2.877,1.258c4.632.155,9.269.089,13.9.155,1.186.016,1.634-.3,1.616-1.6-.111-7.426-.133-14.852-.149-22.279a4.2,4.2,0,0,0-1.4-3.2c-2.592-2.539-5.109-5.156-7.657-7.746-.781-.794-1.2-1.616-.253-2.589.967-.99,1.631-.18,2.254.417,2.393,2.3,4.777,4.606,7.11,6.962,1.5,1.517,1.4,1.492,2.94-.07,2.4-2.428,4.913-4.752,7.369-7.129.841-.816,1.72-.787,2.134.266a2.347,2.347,0,0,1-.4,2.042q-3.557,3.808-7.328,7.414a5.719,5.719,0,0,0-1.887,4.464c.038,6.69-.041,13.376-.076,20.066,0,.885,0,1.774,0,2.757ZM22.922,75.051c.294,1.84.686,3.474.781,5.128.076,1.3.613,1.552,1.77,1.546,3.9-.019,7.8.1,11.694.092,5.529-.009,11.062-.136,16.591-.1,1.584.009,2.153-.509,2.1-2.087a10.268,10.268,0,0,1,.5-3.1c.37-1.274-.1-1.565-1.29-1.562q-15.251.076-30.5.085H22.918Zm16.9,9.3v-.1c-4.84,0-9.684-.013-14.524.022-.455,0-1.3.3-1.3.468a14.073,14.073,0,0,0,.329,4.647c.193.56,1.894.838,2.909.844,8.049.06,16.1.041,24.153.009,4.2-.016,4.252-.126,4.306-4.372.016-1.122-.272-1.565-1.5-1.546-4.786.073-9.576.028-14.366.028ZM28.135,93.129c.332.711.553,1.125.721,1.562a3.8,3.8,0,0,0,4.23,2.665c4.467-.18,8.947-.035,13.424-.057,3.177-.016,3.882-.683,4.467-4.17Z" transform="translate(-0.002 -0.003)" fill="#fff" opacity="0.2"/>
                                        </svg>
                                    )}
                                    {index === 1 && (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="99.997" viewBox="0 0 100 99.997">
                                            <g id="_Downloader.la_-65268f74eca2b-01" data-name="[Downloader.la]-65268f74eca2b-01" transform="translate(-0.004 0.004)" opacity="0.2">
                                                <path id="Path_14652" data-name="Path 14652" d="M72.634,84.4c2.507,3.837,4.863,7.432,7.209,11.039.381.583.712,1.2,1.051,1.808.468.845.964,1.8-.175,2.416a1.876,1.876,0,0,1-2.671-.838c-1.358-2.1-2.821-4.126-4.2-6.211-1.19-1.791-2.36-3.6-3.477-5.432-.552-.9-1.131-.981-2-.468-7.24,4.249-15.151,5.785-23.435,5.575a43.312,43.312,0,0,1-21.037-5.516c-.9-.52-1.264-.22-1.77.559Q18.5,92.887,14.752,98.35c-.663.97-1.386,2.315-2.88,1.253-1.274-.9-.471-2.039.091-2.932,2.189-3.495,4.329-7.034,6.759-10.361,1.1-1.5.855-2.112-.475-3.138a44.768,44.768,0,0,1-15.8-21.85c-6.3-19.354-.227-40.035,16.031-52.261C33.017-1.87,54.166-3.1,69.761,6.386c.977.593,1.92,1.232,1.047,2.625-.8,1.274-1.7.834-2.671.269A42.83,42.83,0,0,0,20.373,12,42.509,42.509,0,0,0,4.747,57.334C12.019,83.189,39.794,96.42,63.931,85.182,78.614,78.347,86.8,66.477,88.937,50.436c.185-1.379.3-2.775.356-4.165.042-1,.3-1.746,1.445-1.752s1.808.653,1.676,1.752a101.041,101.041,0,0,1-1.651,12.051A43.072,43.072,0,0,1,74.687,82.746c-.681.524-1.334,1.075-2.056,1.658Z" transform="translate(0 0)" fill="#fff"/>
                                                <path id="Path_14653" data-name="Path 14653" d="M73.716,42.625a30.472,30.472,0,0,1,15.221,3.837c1.225.667,1.791,1.526,1.065,2.817-.765,1.355-1.732.635-2.674.147C66.611,38.694,45.791,54.254,45.585,74.037c-.143,13.776,11.252,26.364,24.668,27.768a28.181,28.181,0,0,0,30.767-21.836c.433-1.983.66-4.011.922-6.026.119-.9.066-1.819,1.382-1.721a1.625,1.625,0,0,1,1.735,1.9c-.349,12.61-5.865,22.172-17.207,27.817-13.8,6.867-29.461,3.432-38.918-8.714-7.321-9.4-8.511-20.063-4.224-31.175,4.629-12,15.619-19.257,29.011-19.424Z" transform="translate(-27.485 -27.745)" fill="#fff"/>
                                                <path id="Path_14654" data-name="Path 14654" d="M155.617,48.469c2.727-.953,4.846-1.951,5.338-4.933.415-2.517,1.1-4.989,1.7-7.471.244-1,.695-2.028,1.983-1.679,1.323.36,1.522,1.424,1.208,2.66-.5,1.951-.95,3.913-1.428,5.889a5.5,5.5,0,0,0,5.411-4.064c.5-2.507.95-5.024,1.452-7.53.22-1.1.628-2.035,2.063-1.78,1.463.258,1.232,1.316,1.079,2.29-.36,2.294-.723,4.587-1.163,6.867-.276,1.421.056,2.13,1.651,2.3,2.3.248,4.584.747,6.87,1.152,1.072.189,1.735.785,1.494,1.927a1.671,1.671,0,0,1-2.13,1.309,77.6,77.6,0,0,0-8.089-1.25c-1.634-.08-3.324.653-4.961,1.11a1.106,1.106,0,0,0-.576.922c.038.269.51.59.845.681,1.121.3,2.266.52,3.4.761,1.243.262,2.161.908,1.718,2.273-.412,1.267-1.466,1.4-2.723,1.068-2.356-.614-4.741-1.145-7.136-1.6-2.3-.436-4.053.8-5.8,1.948-.014.2-.031.4-.045.6,1.4.4,2.793.834,4.2,1.2,1.222.318,2.384.747,1.822,2.311-.52,1.449-1.686,1.246-2.912.869a55.369,55.369,0,0,0-6.72-1.808,5.128,5.128,0,0,0-3.083.744c-6.539,3.662-13.029,7.418-19.532,11.14-.4.23-.824.642-1.222.625a13.308,13.308,0,0,1-2.322-.5c.209-.765.171-1.91.667-2.234,2.761-1.815,5.638-3.46,8.508-5.111q6.195-3.561,12.439-7.038A4.5,4.5,0,0,0,152,48.9c.566-2.667,1.351-5.289,1.938-7.956.3-1.355,1.117-1.651,2.287-1.508,1.351.164,1.089,1.239.943,2.021-.412,2.22-.96,4.416-1.543,7.017Z" transform="translate(-83.325 -19.216)" fill="#fff"/>
                                                <path id="Path_14655" data-name="Path 14655" d="M101.207,118c-11.932.028-19.738-12.756-14.495-23.743a16.466,16.466,0,0,1,22.346-7.541c.89.461,2.042.96,1.574,2.325-.391,1.149-1.693,1.375-3.107.667-7.143-3.578-15.085-.381-18.335,7.377-2.747,6.56,1.375,14.61,8.738,17.068,6.633,2.213,14.383-2.238,16.254-9.363.307-1.176.339-2.44.747-3.571.223-.625.922-1.431,1.487-1.5,1.079-.136,1.6.705,1.609,1.808a15.6,15.6,0,0,1-6.675,13.311A16.493,16.493,0,0,1,101.207,118Z" transform="translate(-55.357 -55.262)" fill="#fff"/>
                                            </g>
                                        </svg>
                                    )}
                                    {index === 2 && (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="92.433" height="100" viewBox="0 0 92.433 100">
                                            <g id="_Downloader.la_-65268f74eca2b-02" data-name="[Downloader.la]-65268f74eca2b-02" transform="translate(-0.005 -0.002)" opacity="0.15">
                                                <path id="Path_14656" data-name="Path 14656" d="M22.493,16.792a5.614,5.614,0,0,1,1.109.01c1.646.35,2.492-.448,3.21-1.859A31.359,31.359,0,0,1,35.546,4c7.984-6.144,16.314-4.853,23.135,1.5a32.3,32.3,0,0,1,6.945,9.6,2.506,2.506,0,0,0,2.435,1.58,42.778,42.778,0,0,1,13.231,2.346c8.442,3.245,12.936,11.69,10.476,20.389a67.72,67.72,0,0,1-3.747,9.23,2.561,2.561,0,0,0,.013,2.746,30.483,30.483,0,0,1,4.189,11.563c1.039,8.34-3.1,15.1-11.016,18.12a34.644,34.644,0,0,1-12.9,2.288,2.568,2.568,0,0,0-2.66,1.7A30.149,30.149,0,0,1,57.95,95.236c-8.229,6.779-17.665,6.344-24.959-1.427a52.358,52.358,0,0,1-6.214-8.766,3.293,3.293,0,0,0-2.946-1.793A61.676,61.676,0,0,1,13.2,81.678C2.473,78.611-2.209,69.8,1.058,59.1A46.861,46.861,0,0,1,4.322,51.55a2.946,2.946,0,0,0-.108-3.328C1.573,43.852-.21,39.148.025,33.958c.331-7.32,4.532-12.821,11.75-15.151,3.445-1.112,7.081-1.627,10.635-2.412.029.13.057.264.086.394Zm2.864,63.427c1.033-.064,2.676-.118,4.307-.277a74.226,74.226,0,0,0,24.146-6.894A78.69,78.69,0,0,0,79.035,55.2c4.542-4.923,8.251-10.336,9.913-16.94a13.239,13.239,0,0,0-6-14.817A24.4,24.4,0,0,0,71.515,20c-9.427-.661-18.444,1.214-27.187,4.551-13.5,5.155-25.21,12.9-34.3,24.3A35.884,35.884,0,0,0,3.782,60.535c-2.2,7.005.3,13.3,6.8,16.794,4.418,2.377,9.265,2.816,14.779,2.889ZM24.009,30.837l.439.334c.8-.442,1.627-.839,2.387-1.335A81.978,81.978,0,0,1,53.4,18.5c2.619-.607,5.317-.877,7.971-1.348.839-.149,2.05-.149,1.141-1.615a34.6,34.6,0,0,0-7.866-9.265c-5.664-4.45-12.074-4.259-17.506.458a35.947,35.947,0,0,0-9.726,14.293c-1.275,3.216-2.279,6.538-3.407,9.815ZM85.564,52.965c-.543.521-.976.861-1.322,1.275C75.809,64.3,65.292,71.488,53.3,76.64a23.912,23.912,0,0,0-2.114,1.211,11.151,11.151,0,0,0,1.446.512c3.6.575,7.193,1.329,10.819,1.65,5.457.48,10.9.286,16.127-1.691,4.99-1.888,8.473-5.238,9.516-10.577,1.036-5.3-1.386-9.885-3.531-14.779ZM29.152,83.27c2.549,4.1,5.019,7.908,8.737,10.682,5.527,4.119,11.283,4,16.817-.191a31.793,31.793,0,0,0,7.151-8.219c.413-.626.763-1.3,1.23-2.1-.741-.2-1.186-.337-1.643-.435-4.437-.973-8.864-2-13.327-2.86a10.631,10.631,0,0,0-4.021.064c-3.833.776-7.625,1.745-11.445,2.59-1.062.235-2.161.3-3.5.47ZM6.97,47.209a7.965,7.965,0,0,0,.858-.791A54.782,54.782,0,0,1,18.577,35.7a6.489,6.489,0,0,0,2.282-3.839c.7-2.93,1.561-5.82,2.377-8.718.321-1.138.7-2.257,1.173-3.779C20.8,20,17.541,20.374,14.385,21.169A14.809,14.809,0,0,0,4.291,29.232c-3.166,6.487.064,12.049,2.683,17.98Z" transform="translate(0 0)" fill="#fff"/>
                                                <path id="Path_14657" data-name="Path 14657" d="M111.633,135.807a59.136,59.136,0,0,1-15.4-2.832,1.272,1.272,0,0,1-1.042-1.65,58.232,58.232,0,0,1,1.859-6.862c.849-2.244,3.112-3.054,5.082-4.065,2.228-1.141,2.206-1.119,1.43-3.518-1.084-3.356-1.294-6.725.864-9.729a8.177,8.177,0,0,1,9.268-3.143,8.919,8.919,0,0,1,5.734,8.686,24.382,24.382,0,0,1-1.093,5.4c-.305,1.042-.207,1.538.871,1.888,5.321,1.726,7.24,5.905,7.882,11.016.168,1.341-.632,1.808-1.63,2.142A45.932,45.932,0,0,1,111.63,135.8Zm-.28-2.8c.025-.089.051-.178.073-.27,1.526-.133,3.064-.178,4.57-.423,2.082-.34,4.145-.823,6.21-1.255,1.249-.264,1.5-.976,1.252-2.218-.582-2.975-2.651-4.532-5.063-5.915a1.707,1.707,0,0,0-2.346.2c-3.537,3.007-6.477,2.918-10.031-.1-.378-.321-1.154-.639-1.487-.464-2.657,1.386-5.069,3.013-5.95,6.188-.343,1.233-.06,1.815,1.122,2.04q5.821,1.116,11.645,2.215Zm4.879-19.617c.07-3.744-1.831-6.264-4.529-6.64-2.317-.321-5.168,1.856-5.711,4.354-.687,3.175,1.166,7.841,3.782,9.773a1.967,1.967,0,0,0,2.934-.184,11.343,11.343,0,0,0,3.518-7.307Z" transform="translate(-64.899 -70.657)" fill="#fff"/>
                                                <path id="Path_14658" data-name="Path 14658" d="M57.99,191.3c-2.139-.934-4.173-1.694-6.083-2.683-7.879-4.078-14.614-9.688-20.9-15.869a2.313,2.313,0,0,1-.814-1.306,2.8,2.8,0,0,1,.617-1.8c.21-.235,1.068-.1,1.5.127a7.306,7.306,0,0,1,1.576,1.309c6.649,6.43,13.714,12.281,22.261,16.086a11.566,11.566,0,0,1,2.568,1.214,2.37,2.37,0,0,1,.648,1.821c-.032.369-.807.671-1.37,1.093Z" transform="translate(-20.59 -115.644)" fill="#fff"/>
                                                <path id="Path_14659" data-name="Path 14659" d="M196.144,96.056c-.5.559-.855,1.227-1.4,1.462-.337.146-1.093-.242-1.43-.6-4.141-4.488-8.512-8.718-13.892-11.7-3.693-2.044-7.514-3.858-11.28-5.769-.772-.391-1.611-.718-1.208-1.859.394-1.116,1.084-1.367,2.225-.969a56.623,56.623,0,0,1,16.372,8.9c3.468,2.724,6.5,6.007,9.7,9.065a7.686,7.686,0,0,1,.915,1.475Z" transform="translate(-113.803 -52.146)" fill="#fff"/>
                                                <path id="Path_14660" data-name="Path 14660" d="M63.09,146.159c-2.288.178-2.991-.261-3.013-1.894-.064-4.332-.029-8.667.025-13a2.6,2.6,0,0,1,.594-1.732,2.522,2.522,0,0,1,1.732-.34c.242.016.629.588.632.909.038,5.333.029,10.663.029,16.057Z" transform="translate(-40.956 -88.118)" fill="#fff"/>
                                                <path id="Path_14661" data-name="Path 14661" d="M220.7,134.895c0-2.222-.022-4.446.013-6.668.013-.782-.283-1.824,1.052-1.9a1.6,1.6,0,0,1,1.885,1.8q.019,6.989-.006,13.978c0,1.135-.528,1.808-1.739,1.748-1.338-.064-1.233-1.084-1.243-1.974-.022-2.33-.006-4.659-.006-6.989Z" transform="translate(-150.519 -86.173)" fill="#fff"/>
                                            </g>
                                        </svg>
                                    )}

                                    <p>
                                        {reactHtmlParser(i?.data?.short_desc)}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    className="custom_modal mission-vision-modal popup-version-one"
                >
                    <SimpleBar className="main_scroll" style={{ height: '100vh' }}>
                        <Modal.Body>
                            <Container>
                                <Row className={'for-close'} onClick={handleClose}>
                                    <div className="modal-close">
                                        <p>Close</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24.042" height="24.042" viewBox="0 0 24.042 24.042">
                                            <g id="Lines" transform="translate(-332.979 -31.979)">
                                                <line
                                                    id="Line_3965"
                                                    data-name="Line 3965"
                                                    x1="30"
                                                    transform="translate(355.606 33.394) rotate(135)"
                                                    fill="none"
                                                    stroke="black"
                                                    stroke-linecap="round"
                                                    stroke-width="2"
                                                />
                                                <line
                                                    id="Line_3966"
                                                    data-name="Line 3966"
                                                    x1="30"
                                                    transform="translate(334.393 33.393) rotate(45)"
                                                    fill="none"
                                                    stroke="black"
                                                    stroke-linecap="round"
                                                    stroke-width="2"
                                                />
                                                <line
                                                    id="Line_3967"
                                                    data-name="Line 3967"
                                                    x1="30"
                                                    transform="translate(355.607 33.394) rotate(135)"
                                                    fill="none"
                                                    stroke="black"
                                                    stroke-linecap="round"
                                                    stroke-width="2"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </Row>
                            </Container>
                            <Container className={'body-container'}>
                                <Row>
                                    <div className="modal-data d-flex">
                                        <Col className={'legacy-left'}>

                                            <div className={'legacy-left__image-text'}>
                                                <h3>{reactHtmlParser(modalData?.data?.subtitle)}</h3>
                                                <p>{reactHtmlParser(modalData?.data?.description)}</p>
                                            </div>
                                        </Col>

                                    </div>
                                </Row>
                            </Container>
                        </Modal.Body>
                    </SimpleBar>
                </Modal>
            </div>
        </StyledAboutSection>
    );
};

const StyledAboutSection = styled.section`
  background: rgb(232, 232, 232);
  .mission-vision {
    background-color:#F2F2F2 ;
    position: relative;
    &__single {
      cursor: pointer;
      padding: 40px;
      background-color: #6EAFC4;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap:72px;
      position: relative;
      svg{
        position: absolute;
        top: 4%;
        @media(max-width: 767px){
          top: 10%;
        }
      }
      h3 {

        color: #ffffff;
      }
      
      

      p {
        color: #ffffff;
      }
    }
  }
  .mission-vision:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 50%;
    bottom: 0;
    left: 0;
    background: #E8E8E8;
  }




  @media (max-width: 767px) {
    .mission-vision {
      background-color: #F2F2F2;
      .col-sm-6{
        flex-basis: 100%;
        margin-bottom: 20px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      &__single{
        position: unset;
        padding: 60px 15px 55px;
      }
      .row{
        gap:30px;
      }
      .col-md-4{
        position: relative;
      }
    }
    .mission-vision:before{
      content: unset;
    }

  }
`;
export default React.memo(AboutSection);
